// React Imports
import { Outlet } from "react-router";

// External Libraries
import C from "classnames";

// Toolkit Imports
import { Header } from "sj-ui-toolkit/src/atlas/components";
import { UserContextProvider } from "sj-ui-toolkit/src/atlas/contexts/User/UserContextProvider";
import { SettingsContextProvider } from "sj-ui-toolkit/src/atlas/contexts/Settings/SettingsContextProvider";
import { useSegmentPage } from "sj-ui-toolkit/src/hooks/useSegment.js";
import { themeClasses } from "sj-ui-toolkit/src/atlas/utils";
import { useBreadcrumb } from "sj-ui-toolkit/src/atlas/hooks/useBreadcrumbs";
import { BreadcrumbProvider } from "sj-ui-toolkit/src/atlas/contexts/Breadcrumb/BreadcrumbProvider";

// Local Components
import { ProfileHeader } from "./ProfileHeader";
import { ProfileTabs } from "./ProfileTabs";

// Layout component for user profile pages
export function ProfileLayout() {
  useSegmentPage();
  useBreadcrumb({ label: "Profile", route: "/profile", display: "page" });

  return (
    <div className={C("atlas-bg-home", themeClasses.flexLayout)}>
      <UserContextProvider>
        <SettingsContextProvider>
          <BreadcrumbProvider>
            <Header />
            <main id="main-content" className={themeClasses.flexMain}>
              <ProfileHeader />
              <ProfileTabs />
              <Outlet />
            </main>
          </BreadcrumbProvider>
        </SettingsContextProvider>
      </UserContextProvider>
    </div>
  );
}
